import type {
  CreateCategoryTransactionParameters,
  CreateCategoryTransactionReturnTypes,
} from './types'

type CreateBlankTransactionParameters = CreateCategoryTransactionParameters & {
  comment?: string
}

type CreateBlankTransactionReturnTypes = CreateCategoryTransactionReturnTypes

export const createBlankTransaction = ({
  actionId,
  timestamp,
  comment,
  assetBalances,
  assetBorrows,
  usedBalances,
}: CreateBlankTransactionParameters): CreateBlankTransactionReturnTypes => ({
  transaction: {
    actionId,
    order: 0,
    timestamp,
    comment,
    category: 'blank',
    ins: [],
    outs: [],
  },
  assetBalances,
  assetBorrows,
  usedBalances,
})
